jQuery(function($) {
    console.log('[DEBUG] quote-slider.js loaded');
    console.log('[DEBUG] jQuery.fn.slick available:', typeof $.fn.slick);
    console.log('[DEBUG] Quote sliders found:', $('.module--quote-slider').length);
    
    $('.module--quote-slider').each(function() {
        var $module = $(this);
        var $slider = $module.find('.quote-slider');
        var $dots = $module.find('.quote-slider__dots');

        $slider.slick({
            dots: true,
            arrows: true,
            adaptiveHeight: true,
            appendDots: $dots,
            prevArrow: '<button type="button" class="slick-prev"><span class="icon material-symbols-outlined">west</span></button>',
            nextArrow: '<button type="button" class="slick-next"><span class="icon material-symbols-outlined">east</span></button>'
        });
    });
});
